import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=180072da&scoped=true"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180072da",
  null
  
)

export default component.exports